import { useEffect, useState } from "react";

export function useElementWidth(ref) {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!ref.current) return;

    const measureWidth = () => {
      const element = ref.current;
      if (element) setWidth(element.offsetWidth);
    };

    measureWidth();

    // Use ResizeObserver to detect when element size changes due to content changes
    const resizeObserver = new ResizeObserver(() => {
      measureWidth();
    });

    resizeObserver.observe(ref.current);

    // Keep window resize listener as fallback
    window.addEventListener("resize", measureWidth);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", measureWidth);
    };
  }, [ref]);

  return width;
}
